
export default function Hero() {
  return (
    <section className="relative h-screen w-full overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://static.owlting.com/booking/image/h/e58601d0-6db2-459c-a50a-2573f839a561/images/QWLiKoAPAGZup9Fv5GH21WyBTJG8K4y2u0erDLO7.jpeg)',
        }}
      >
        <div className="absolute inset-0 bg-black/40"></div>
      </div>
      
      <div className="relative h-full flex items-center justify-center">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center text-white">
            <h1 className="text-5xl md:text-7xl font-bold mb-6" style={{ fontFamily: '"Pacifico", serif' }}>
              離海5min b&b
            </h1>
            <p className="text-xl md:text-2xl mb-4 leading-relaxed">
              位於屏東恆春下水泉的歐美風格小木屋
            </p>
            <p className="text-lg md:text-xl mb-8 leading-relaxed max-w-3xl mx-auto">
              鄰近沙灘，是小孩也是毛小孩的天堂，環境優美，人少幽靜<br />
              抵達海邊開車僅要3~5分鐘，歡迎喜愛大自然的你來脫離都市生活
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center mt-12">
              <a
                href="#rooms"
                className="px-8 py-4 bg-teal-500 hover:bg-teal-600 text-white font-semibold rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                查看房型
              </a>
              <a
                href="https://www.booking-owlnest.com/5minbnb?lang=zh_TW&adult=1&child=0&infant=0"
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-4 bg-white hover:bg-gray-100 text-gray-900 font-semibold rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                立即預訂
              </a>
            </div>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <a href="#rooms" className="cursor-pointer">
          <i className="ri-arrow-down-line text-white text-4xl"></i>
        </a>
      </div>
    </section>
  );
}
